<div class="flex flex-col w-full gap-4 p-4">

    <div class="flex flex-row justify-between w-full">

        <div>
            <h6 id="h-sd-proxy-vote">Place Vote</h6>
            <p>
                <span class="body-large-regular text-subtle">Committee Member: </span>
                <span class="body-large-bold">{{ voteData?.committeeMember }}</span>
              </p>
              <p *ngIf="voteData?.hasHistories">
                <span class="body-large-regular text-subtle"> Vote placed: </span>
                <span class="body-large-bold">{{
                  voteData?.submitted | date : "dd/MM/yyyy"
                }}</span>
              </p>
        </div>

        <button id="srs-proxy-vote-close-icon" (click)="close()">
            <span class="text-lg material-symbols-rounded text-subtle">close</span>
          </button>
    </div>

    <mat-divider class="mb-4 border-gray-300"></mat-divider>

    <form [formGroup]="sdProxyVoteForm" class="flex flex-col w-full gap-4">
        <app-select-proxy-vote-option
            [voteOptions]="sdVoteOptions"
            [selectedVoteOptionId]="initialSelectedVoteOptionId"
            formControlName="proxyVoteOptionsCtrl"
        >
        </app-select-proxy-vote-option>

        <app-sd-certificate-of-appreciation
            *ngIf="isCoaManagedBySf === false"
            formControlName="certificateOfAppreciationCtrl"
            [committeeMember]="voteData"
        ></app-sd-certificate-of-appreciation>

        <div id="add-authorisation-doc" class="flex flex-col flex-grow">
            <files-upload
              title="Attach an authorisation document"
              accept=".pdf,.zip,.doc,.docx,.png,.rtf,.tif,.txt,.msg"
              formControlName="authorisationDocumentCtrl"
              [progress]="authDocUploadProgress"
            ></files-upload>
          </div>
    </form>

    <mat-divider class="border-gray-300"></mat-divider>

    <div class="flex flex-row justify-end gap-6">
      <button
        class="btn btn-neutral"
        (click)="close()"
        id="btn-sd-proxy-vote-cancel"
      >
        Cancel
      </button>
      <button
        class="btn btn-primary"
        id="btn-sd-proxy-vote-submit"
        (click)="submit()"
        [disabled]="sdProxyVoteForm.invalid"
      >
        Submit
      </button>
    </div>
</div>

